import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-05/lesson-23/task-01";

const task: Slide = {
  title:
    "What is the main problem that is encountered in objective rating of sound insulation of building elements and constructions?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
